import { TwoColumnRiverProps } from '@zapier/design-system';
import { COLOR_KEYS } from '../../../constants';

export const DEFAULT_VALUES = {
  backgroundColor: COLOR_KEYS.neutral100,
  heading: 'Two column river',
  description:
    '<p><strong>Availability:</strong> Zapier has globally distributed SRE and Security teams that are on-call 24/7. To ensure users have real-time service availability updates, Zapier maintains a Status page.</p><p><strong>Logging: </strong>Zapier maintains a comprehensive log of all user and Zap activities. Zap activities are extensively logged internally for troubleshooting and support, and presented in summary in Zap History to inform users directly.</p>',
  ctaText: 'Click me',
  ctaHref: '#',
  ctaColor: 'primary' as TwoColumnRiverProps['ctaColor'],
  secondaryCtaText: 'Click me too',
  secondaryCtaHref: '##',
  isReversed: false,
};
